module.exports = __webpack_public_path__ + "static/media/blockrise.cfea3b37.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/blockrise.webp
// module id = 283
// module chunks = 0